import React, { useState } from 'react';

import Container from 'react-bootstrap/esm/Container'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/esm/Col'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Toast from 'react-bootstrap/Toast';
import Image from 'react-bootstrap/Image';

import '../utils/general.css';
import '../utils/education.css';

import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import { useLanguage } from '../components/languageContext'; // Importez le hook useLanguage
import Seo from '../components/seo';

import RandomShapes from '../components/ramdomshapes';
import AwsCertified from '../assets/pictures/aws-certified.webp';

export default function Education() {
  const { language } = useLanguage();

  // Importez les traductions en fonction de la langue
  const translations = language === 'en' ? enTranslations : frTranslations;

  const [showA, setShowA] = useState(false);
  const [showB, setShowB] = useState(false);
  const [showC, setShowC] = useState(false);
  const [showD, setShowD] = useState(false);
  const [showE, setShowE] = useState(false);
  const [showF, setShowF] = useState(false);

  const toggleShowA = () => setShowA(!showA);
  const toggleShowB = () => setShowB(!showB);
  const toggleShowC = () => setShowC(!showC);
  const toggleShowD = () => setShowD(!showD);
  const toggleShowE = () => setShowE(!showE);
  const toggleShowF = () => setShowF(!showF);

  const data = {
    0: {txt: "text-primary", bg:  "bg-light", border: "border-primary", title: translations.education.degree.m2, data: translations.education.degree.m2_data, loc: translations.education.degree.m2_loc, date: translations.education.degree.m2_date},
    1: {txt: "text-success", bg:  "bg-light", border: "border-success", title: translations.education.degree.m1, data: translations.education.degree.m1_data, loc: translations.education.degree.m1_loc, date: translations.education.degree.m1_date},
    2: {txt: "text-warning", bg:  "bg-light", border: "border-warning", title: translations.education.degree.m1_b, data: translations.education.degree.m1_b_data, loc: translations.education.degree.m1_b_loc, date: translations.education.degree.m1_b_date},
    3: {txt: "text-danger", bg:  "bg-light", border: "border-danger", title: translations.education.degree.li, data: translations.education.degree.li_data, loc: translations.education.degree.li_loc, date: translations.education.degree.li_date},
    4: {txt: "text-secondary", bg: "bg-light", border: "border-secondary", title: translations.education.degree.bac, data: translations.education.degree.bac_data, loc: translations.education.degree.bac_loc, date: translations.education.degree.bac_date}
  };

  return (
    <Container fluid className="ps-education">
      <Seo title={translations.seo.education.title} description={translations.seo.education.description} />
      <Row className='ps-row pb-5'>
        <h1 className="ps-page-title mt-5 mb-2">{translations.education.title}</h1>
      </Row>
      <Row className='my-5 justify-content-center align-items-center'>
        <Col sm={12} md={8} lg={6}>
          <div className='ps-education-aws-wrapper mx-auto'>
            <span className='ps-education-aws-ring'></span>
            <span className='ps-education-aws-ring ps-education-aws-ring-delay'></span>
            <Card className='ps-education-aws text-center text-light'>
              <Card.Header className='d-flex justify-content-between align-items-center'>
                <Card.Title as="h2" className='mb-0'><strong>{translations.education.aws.title}</strong></Card.Title>
                <span className='ps-education-aws-badge'>{translations.in_prog}</span>
              </Card.Header>
              <Card.Body>
                <Image src={AwsCertified} alt="AWS Certified Developer Associate badge" loading="lazy" className='ps-education-aws-img' />
                <Card.Text>
                  {translations.education.aws.info}
                </Card.Text>
                <Button className='ps-education-aws-btn' href="https://aws.amazon.com/fr/certification/certified-developer-associate/" target="_blank" rel="noopener noreferrer">
                  {translations.education.aws.link}
                </Button>
              </Card.Body>
              <Card.Footer><em>{translations.education.aws.footer}</em></Card.Footer>
            </Card>
          </div>
        </Col>
      </Row>
      <Row className='mx-2 mb-5 ps-education-row-1 justify-content-center align-items-center'>
        <Col sm={12} md={5} lg={4} className=''>
          <Card bg="dark" className="text-center border-primary text-light " variant="success">
            <Card.Header>
              <Card.Title as="h2"><strong>{translations.education.school42.title}</strong></Card.Title>
            </Card.Header>
            <Card.Body className='text-light' bg="dark">
              <Card.Text>
                {translations.education.school42.info}
              </Card.Text>
              <Button href="https://42.fr/en/homepage/">{translations.education.school42.link}</Button>
            </Card.Body>
            <Card.Footer >3 {translations.year}s - 2019/2022</Card.Footer>
          </Card>
        </Col>
        <Col sm={12} md={7} lg={8}>
          <Row className="mx-sm-3 mx-0 my-2 justify-content-around align-items-center" > {/* first line  */}
            <Col sm={6} lg={4} className='text-center '>
              <Button onClick={toggleShowA} aria-expanded={showA} className="mb-2" variant="success">
                {translations.education.school42.t1.title}
              </Button>
              <Toast show={showA} onClose={toggleShowA} bg="success" className='mb-5'>
                <Toast.Header>
                  <strong className='me-auto'>{translations.education.school42.t1.group}</strong>
                </Toast.Header>
                <Toast.Body className='text-center'>
                  <strong>{translations.education.school42.t1.info}</strong><br />
                  <div className='my-1'>
                    {translations.education.school42.t1.info2}<br />
                    {translations.education.school42.t1.info3}<br />
                    {translations.education.school42.t1.info4}<br />
                  </div>
                  <div className='my-1'>
                    <em>{translations.education.school42.t1.techno}</em><br />
                  </div>
                </Toast.Body>
                <div className='d-flex justify-content-center mb-1 '>
                  <Button href="https://github.com/PierreSaumet/42-Ft_Transcendence" target="_blank" className='ps-education-42-t1'>{translations.git_link}</Button>
                </div>
              </Toast> 
            </Col>
            <Col sm={6} lg={4} className='text-center '>
              <Button onClick={toggleShowB} aria-expanded={showB} className="mb-2" variant="primary">
                {translations.education.school42.t2.title}
              </Button>
              <Toast show={showB} onClose={toggleShowB} bg="primary">
                <Toast.Header className='text-center'>
                  <strong className='me-auto'>{translations.education.school42.t2.group}</strong>
                </Toast.Header>
                <Toast.Body>
                  <strong>{translations.education.school42.t1.info}</strong><br />
                  <div className='my-1'>
                    {translations.education.school42.t2.info2}<br />
                    {translations.education.school42.t2.info3}
                  </div>
                  <div className='my-1'>
                    <em>{translations.education.school42.t2.techno}</em><br />
                  </div>  
                </Toast.Body>
                <div className='d-flex justify-content-center mb-1'>
                  <Button href="https://github.com/PierreSaumet/42-Webserv" target="_blank" className='ps-education-42-t2'>{translations.git_link}</Button>
                </div>
              </Toast>
            </Col>
            <Col sm={6} lg={4} className='text-center '>
              <Button onClick={toggleShowC} aria-expanded={showC} className="mb-2" variant="danger">
                {translations.education.school42.t3.title}
              </Button>
              <Toast show={showC} onClose={toggleShowC} bg="danger">
                <Toast.Header className='text-center'>
                  <strong className='me-auto'>{translations.education.school42.t3.group}</strong>
                </Toast.Header>
                <Toast.Body>
                  <strong>{translations.education.school42.t3.info}</strong><br />
                  <div className='my-1'>
                    {translations.education.school42.t3.info2}<br />
                    {translations.education.school42.t3.info3}<br />
                    {translations.education.school42.t3.info4}
                  </div>
                  <div className='my-1'>
                    <em>{translations.education.school42.t3.techno}</em><br />
                  </div>
                </Toast.Body>
                <div className='d-flex justify-content-center mb-1'>
                  <Button href="https://github.com/PierreSaumet/42-Ft_containers" target="_blank" className='ps-education-42-t3'>{translations.git_link}</Button>
                </div>
              </Toast>
            </Col>
          </Row>
          <Row className="mx-sm-3 mx-0 my-2 justify-content-around align-items-center" >   {/* second line  */}
            <Col sm={6} lg={4} className='text-center'>
              <Button onClick={toggleShowD} aria-expanded={showD} className="mb-2" variant="warning">
                {translations.education.school42.t4.title}
              </Button>
              <Toast show={showD} onClose={toggleShowD} bg="warning">
                <Toast.Header className='text-center'>
                  <strong className='me-auto'>{translations.education.school42.t4.group}</strong>
                </Toast.Header>
                <Toast.Body className='text-black'>
                  <strong>{translations.education.school42.t4.info}</strong><br />
                  <div className='my-1'>
                    {translations.education.school42.t4.info2}<br />
                    {translations.education.school42.t4.info3}<br />
                  </div>
                  <div className='my-1'>
                    <em>{translations.education.school42.t4.techno}</em><br />
                  </div>
                </Toast.Body>
                <div className='d-flex justify-content-center mb-1'>
                  <Button  href="https://github.com/PierreSaumet/Cub3d" target="_blank" className='ps-education-42-t4 text-black'>{translations.git_link}</Button>
                </div>
              </Toast>
            </Col>
            <Col sm={6} lg={4} className='text-center mb-1'>
              <Button onClick={toggleShowE} aria-expanded={showE} className="mb-2" variant="info">
                {translations.education.school42.t5.title}
              </Button>
              <Toast show={showE} onClose={toggleShowE} bg="info">
                <Toast.Header className='text-center'>
                  <strong className='me-auto'>{translations.education.school42.t5.group}</strong>
                </Toast.Header>
                <Toast.Body className='text-black'>
                  <strong>{translations.education.school42.t5.type}</strong><br />
                  <div className='my-1'>
                    {translations.education.school42.t5.info}<br />
                    {translations.education.school42.t5.info2}<br />
                    {translations.education.school42.t5.info3}<br />
                    {translations.education.school42.t5.info4}<br />
                    {translations.education.school42.t5.info5}
                  </div>
                  <div className='my-1'>
                    <em>{translations.education.school42.t5.techno}</em>
                  </div>
                </Toast.Body>
                <div className='d-flex justify-content-center mb-1'>
                  <Button href="https://github.com/PierreSaumet/push_swap" target="_blank" className='ps-education-42-t5 text-black'>{translations.git_link}</Button>
                </div>
              </Toast>
            </Col>
            <Col sm={6} lg={4} className='text-center'>
              <Button onClick={toggleShowF} aria-expanded={showF} className="mb-2" variant="light">
                {translations.education.school42.t6.title}
              </Button>
              <Toast show={showF} onClose={toggleShowF} bg="light" className='mb-1'>
                <Toast.Header className='text-center'>
                  <strong className='me-auto'>{translations.education.school42.t6.group}</strong>
                </Toast.Header>
                <Toast.Body className='text-black'>
                  <strong>{translations.education.school42.t6.type}</strong><br />
                  <div className='my-1'>
                    {translations.education.school42.t6.info}<br />
                    <em>{translations.education.school42.t6.info2}</em>
                  </div>
                  <div className='my-1'>
                    {translations.education.school42.t6.info3}<br />
                    <em>{translations.education.school42.t6.info4}</em>
                  </div>
                </Toast.Body>
                <div className='d-flex justify-content-center mb-1'>
                  <Button href="https://github.com/PierreSaumet/42-Ft_server" target="_blank" className='ps-education-42-t6 text-black'>{translations.git_link}</Button>
                </div>
              </Toast>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className=' my-5 justify-content-center align-items-center'>
        <div className='position-relative my-5'>
          <RandomShapes />
          <Card  className="text-center border-primary text-light position-absolute top-50 start-50 translate-middle bg-trans" variant="success" style={{ width: '18rem' }}>
            <Card.Header>
              <Card.Title as="h2" className=''><strong>{translations.education.oc.title}</strong></Card.Title>
            </Card.Header>
            <Card.Body className='text-light'>
              <Card.Text>
                {translations.education.oc.info}
              </Card.Text>
              <Button className='text-light' href="https://openclassrooms.com/en/paths/880-python-developer">{translations.education.oc.link}</Button>
            </Card.Body>
            <Card.Footer > 1 {translations.year} - 2019</Card.Footer>
          </Card>
        </div>
        
      </Row>
      
      <Row className='mx-2 my-5 ps-education-row-3 '>
        {Array.from({ length: 5 }).map((_, idx) => (
          <Col key={idx}>
            <Card  bg="dark" className={`text-light ${data[idx].bg} ${data[idx].border} my-3 `}>
              <Card.Header>
                <Card.Title as="h2" className={`text-light text-center `}><strong>{data[idx].title}</strong></Card.Title>
              </Card.Header>
              <Card.Body className='text-center'>
                <Card.Title className={`text-light `}>{data[idx].data}</Card.Title>
                <Card.Text className='text-light'>
                  {data[idx].loc}
                </Card.Text>
              </Card.Body>
              <Card.Footer className={`${data[idx].txt} text-center `}><em>{data[idx].date}</em></Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  )
}